
export default {
  setup() {
    return {};
  }
};
